import { componentFactoryOf } from 'vue-tsx-support';

import { injectStylesMixin } from '../../mixins/inject-styles';

import styles from './jtn-ui-share.styles.scss?module';

type Events = {
  onShared: Social;
  onLinkCopied: void;
};

type Social = 'vk' | 'twitter' | 'ok' | 'telegram' | 'wa';

const POPOVER_TIMEOUT = 2000;

const SOCIAL_ICON_SIZE = 24;
const SOCIAL_ICON_COLOR = '#37404d';

export default componentFactoryOf<Events>()
  .mixin(injectStylesMixin(styles))
  .create({
    name: 'JtnUiShareredesign',
    props: {
      socials: {
        type: Array as () => Social[],
        default: () => ['vk', 'twitter', 'ok', 'telegram'] as Social[]
      },
      isInOneLine: {
        type: Boolean,
        default: false
      },
      copyLink: {
        type: String,
        default: ''
      },
      isCaptionShown: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        hidePopup: true,
        timeoutId: 0,
        linkCopied: false
      };
    },
    computed: {
      hasCopyBtn(): boolean {
        return this.copyLink.length > 0;
      }
    },
    methods: {
      copyShareLink() {
        const link = this.$refs.link as HTMLElement;
        const range = document.createRange();
        range.selectNode(link);

        const selection = window.getSelection();

        if (selection) {
          selection.removeAllRanges();
          selection.addRange(range);

          try {
            document.execCommand('copy');
            this.showCopyMessage();
            this.$emit('linkCopied');
          } catch (error) {
            console.error(
              `Произошла ошибка при копировании ссылки на пост: ${
                (error as Error).message
              }`
            );
          }

          selection.removeRange(range);
        }
      },
      showCopyMessage() {
        clearTimeout(this.timeoutId);

        this.linkCopied = true;
        this.timeoutId = window.setTimeout(() => {
          this.linkCopied = false;
        }, POPOVER_TIMEOUT);
      },
      getIcon(type: Social | 'copy-link') {
        switch (type) {
          case 'copy-link':
            return (
              <svg
                style={{ color: SOCIAL_ICON_COLOR }}
                width={SOCIAL_ICON_SIZE}
                height={SOCIAL_ICON_SIZE}
                class={styles.copyLink}
              >
                <use xlinkHref="/dist/legacy/svg-sprites/jtn-social.478c99898e9d4753ae7bc5e64d408199.svg#jtn-social-copy-link"></use>
              </svg>
            );

          case 'ok':
            return (
              <svg
                style={{ color: SOCIAL_ICON_COLOR }}
                width={SOCIAL_ICON_SIZE}
                height={SOCIAL_ICON_SIZE}
              >
                <use xlinkHref="/dist/legacy/svg-sprites/jtn-social.478c99898e9d4753ae7bc5e64d408199.svg#jtn-social-ok"></use>
              </svg>
            );

          case 'telegram':
            return (
              <svg
                style={{ color: SOCIAL_ICON_COLOR }}
                width={SOCIAL_ICON_SIZE}
                height={SOCIAL_ICON_SIZE}
              >
                <use xlinkHref="/dist/legacy/svg-sprites/jtn-social.478c99898e9d4753ae7bc5e64d408199.svg#jtn-social-telegram"></use>
              </svg>
            );

          case 'twitter':
            return (
              <svg
                style={{ color: SOCIAL_ICON_COLOR }}
                width={SOCIAL_ICON_SIZE}
                height={SOCIAL_ICON_SIZE}
              >
                <use xlinkHref="/dist/legacy/svg-sprites/jtn-social.478c99898e9d4753ae7bc5e64d408199.svg#jtn-social-twitter"></use>
              </svg>
            );

          case 'vk':
            return (
              <svg
                style={{ color: SOCIAL_ICON_COLOR }}
                width={SOCIAL_ICON_SIZE}
                height={SOCIAL_ICON_SIZE}
              >
                <use xlinkHref="/dist/legacy/svg-sprites/jtn-social.478c99898e9d4753ae7bc5e64d408199.svg#jtn-social-vk"></use>
              </svg>
            );

          case 'wa':
            return (
              <svg
                style={{ color: SOCIAL_ICON_COLOR }}
                width={SOCIAL_ICON_SIZE}
                height={SOCIAL_ICON_SIZE}
              >
                <use xlinkHref="/dist/legacy/svg-sprites/jtn-social.478c99898e9d4753ae7bc5e64d408199.svg#jtn-social-wa"></use>
              </svg>
            );

          default:
            break;
        }
      },
      emitShareClicked(type: Social) {
        this.$emit('shared', type);
      }
    },
    render() {
      const { $attrs: attrs } = this;

      return (
        <div {...attrs}>
          {this.isCaptionShown && (
            <p class={styles.shareCaption}>{this.$slots.caption || 'Поделиться'}</p>
          )}
          <div class={this.isInOneLine ? styles.inOneLine : ''}>
            <ul class={[styles.shareList]}>
              {this.hasCopyBtn && (
                <li
                  class={[
                    styles.shareListItem,
                    this.linkCopied ? styles.showCopyMessage : ''
                  ]}
                >
                  <button
                    class={styles.shareBtn}
                    data-test={`btn-share-copy`}
                    onClick={() => {
                      this.copyShareLink();
                    }}
                  >
                    {this.getIcon('copy-link')}
                    <span class={styles.copyMessage}>Ссылка скопирована!</span>
                    <span class={styles.hiddenLink} ref="link">
                      {this.copyLink}
                    </span>
                  </button>
                </li>
              )}
              {this.socials.map(item => (
                <li key={item} class={styles.shareListItem}>
                  <button
                    class={styles.shareBtn}
                    data-test={`btn-share-${item}`}
                    onClick={() => this.emitShareClicked(item)}
                  >
                    {this.getIcon(item)}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>
      );
    }
  });

export { Events, Social };
